import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http:HttpClient) { }
  getsopList(){
    let httpParam : HttpParams=new HttpParams();

    return this.http.get( environment.API_URL+"/api/app/user/doc/list/S" ,{ observe : "body", params : httpParam,responseType : "json"}) 
  }
  
  getSOPpdf(fileName:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/app/user/doc/download/"+fileName ,{headers : header, observe : "response", params : httpParam,responseType : "blob"})  
  }
  uploadSOPExcel(userListFile:File) {
    let contenttype= undefined;
    const formData = new FormData();
    formData.append("file", userListFile)
    //formData.append("userParams",JSON.stringify(bulkUserData), { type: 'text/plain' );
    // formData.append('userParams', new Blob([JSON.stringify(bulkUserData)], {
    //   type: 'application/json'
    // }));
    let header = new HttpHeaders();
    //let headers = new HttpHeaders({ 'Content-Type': });

    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/app/user/doc/upload/S",formData ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }



  getPolicyList(){
    let httpParam : HttpParams=new HttpParams();

    return this.http.get( environment.API_URL+"/api/app/user/doc/list/P" ,{ observe : "body", params : httpParam,responseType : "json"}) 
  }
  
  getPolicypdf(fileName:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/app/user/doc/download/"+fileName ,{headers : header, observe : "response", params : httpParam,responseType : "blob"})  
  }
  uploadPolicyExcel(userListFile:File) {
    let contenttype= undefined;
    const formData = new FormData();
    formData.append("file", userListFile)
    //formData.append("userParams",JSON.stringify(bulkUserData), { type: 'text/plain' );
    // formData.append('userParams', new Blob([JSON.stringify(bulkUserData)], {
    //   type: 'application/json'
    // }));
    let header = new HttpHeaders();
    //let headers = new HttpHeaders({ 'Content-Type': });

    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/app/user/doc/upload/P",formData ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  
  downloadDoc(Id:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/order/invoice/v1?orderId="+Id ,{headers : header, observe : "body", params : httpParam,responseType : "blob"})  
  
}
}
